<template>
  <div :class="$style.wrap">
    <header>
      <span>{{title}}</span>
      <img :src="`${$cdnLink}/wanXin/orangeTheme/fanhui.png`" alt :class="$style.fanhui" @click="turnoff" />
    </header>
    <main>
      <div :class="$style.content">
        <p>
          <img :src="`${$cdnLink}/common/time_ico_1.png`" alt="" />
          <span :class="$style.label">活动时间</span>
          <span>{{ bindGiftInfo.date_detail }}</span>
        </p>
        <p>
          <img :src="`${$cdnLink}/common/bag_ico_1.png`" alt="" />
          <span :class="$style.label">活动描述</span>
          <span>{{ bindGiftInfo.detail }}</span>
        </p>
      </div>
      <div :class="$style.code">
        <span>礼包码：{{ code }}</span>
        <button :class="`${$style.copy} copy-btn`" :data-clipboard-text="code">复制</button>
      </div>
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getGiftNum, giftDetail } from '@/api/activity';
import Clipboard from 'clipboard';
import { setStorage, getStorage } from '@/libs/utils';

export default {
  name: '',
  data() {
    return {
      bindGiftInfo: {},
      code: '',
      title: '活动有礼'
    };
  },
  props: ['giftId', 'giftType'],
  mounted() {
    if (this.giftType == 1) this.title = '绑定有礼'
    this.copyInit();
    this.getGiftInfo()
  },
  computed: {
    ...mapState({
      userState: (state) => state.user,
    }),
  },
  methods: {
    async getGiftInfo() {
      const appkey = getStorage('appkey');
      const giftList = await giftDetail({ appkey, gift_id: this.giftId });
      this.bindGiftInfo = giftList.content.find(item => item.type == this.giftType);
      if (!this.bindGiftInfo) {
        this.turnoff()
        return
      }
      this.getCode()
    },
    async getCode() {
      const r = await getGiftNum({
        appkey: this.userState.appkey,
        user_id: this.userState.user_id,
        type: this.bindGiftInfo.type,
        id: this.bindGiftInfo.id,
      });
      this.code = r.content.gift_num;
    },
    copyInit() {
      this.copy = new Clipboard('.copy-btn');
      this.copy.on('success', (e) => {
        this.$toast('复制成功');
      });
    },
    turnoff() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" module>
@import '../../assets/css/common.scss';

.wrap {
  @include full-screen-window();
  > header {
    position: relative;
    > span {
      font-weight: 600;
      font-style: italic;
    }
    .fanhui {
      position: absolute;
      top: 17px;
      right: 17px;
      width: 17px;
      height: 12px;
    }
  }
  > main {
    padding: 20px;
    position: relative;
  }
  .content {
    > p {
      font-size: 12px;
      padding: 5px 0;
      margin: 0 40px 0 10px;
      display: flex;
      line-height: 16px;
      > .label {
        flex: none;
        margin-right: 5px;
      }
      > img {
        height: 15px;
        margin-right: 6px;
      }
    }
    > p:nth-child(1) {
      border-bottom: 1px solid #cccccc;
    }
  }
  .submit {
    margin: 54px auto 0;
    width: 293px;
    height: 41px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 15px;
    border: none;
    outline: none;
    background: #ff5b58;
    border-radius: 20px;
  }
  .code {
    position: absolute;
    font-size: 14px;
    text-align: center;
    bottom: 20px;
    left: 0;
    right: 0;
    margin: auto;
    .copy {
      padding: 4px 12px;
      color: #ffffff;
      border: none;
      outline: none;
      font-size: 12px;
      background: #ff5b58;
      border-radius: 10px;
      margin-left: 20px;
    }
  }
}
.content {
  > p {
    font-size: 12px;
    padding: 5px 0;
    margin: 0 40px 0 10px;
    display: flex;
    line-height: 16px;
    > .label {
      flex: none;
      margin-right: 5px;
    }
    > img {
      height: 15px;
      margin-right: 6px;
    }
  }
  > p:nth-child(1) {
    border-bottom: 1px solid #cccccc;
  }
}
.submit {
  margin: 54px auto 0;
  width: 293px;
  height: 41px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 15px;
  border: none;
  outline: none;
  background: #ff5b58;
  border-radius: 20px;
}
.code {
  font-size: 14px;
  text-align: center;
  margin-top: 60px;
  .copy {
    padding: 4px 12px;
    color: #ffffff;
    border: none;
    outline: none;
    font-size: 12px;
    background: #ff5b58;
    border-radius: 10px;
    margin-left: 20px;
  }
}
</style>
